
import { Options, Prop, Vue } from 'vue-property-decorator'

@Options({
  name: 'RtlPlus'
})
export default class RtlPlus extends Vue {
  @Prop({
    type: Boolean,
    default: true
  })
  readonly withSlogan!: boolean
}
